module.exports = __webpack_public_path__ + "static/media/Coders-Crux.401ef61f.eot";